import axios from "axios";
import env from "app/utils/env";
import { FETCH_NAVLOGS, SAVE_NAVLOG } from "app/pages/Listing/NavLogs/navLogActionTypes";
import { getCredentials } from "app/utils/auth";

export const fetchNavLogs = ({ authToken }) => {
	const headers = {
		Authorization: authToken,
		"Content-type": "application/json",
	};

	return {
		type: FETCH_NAVLOGS,
		promise: axios.get(`${env("NAV_LOGS_API_URL")}/navlog`, { headers }),
	};
};

export const saveNavLog = ({ product = {}, quotationURL }) => {
	const { token } = getCredentials();
	const headers = {
		Authorization: token,
		"Content-type": "application/json",
	};

	// redirectToProductPage allow the back button on quote page to force back button to redirect to the product page
	let quoteUrl = quotationURL && `${quotationURL}&redirectToProductPage=true`;

	return {
		type: SAVE_NAVLOG,
		promise: axios.post(
			`${env("NAV_LOGS_API_URL")}/navlog`,
			{
				...(product?.id && { id: product.id }),
				quotationURL: quoteUrl,
			},
			{
				headers,
			}
		),
	};
};

export const removeNavLog = ({ id }) => {
	const { token } = getCredentials();
	const headers = {
		Authorization: token,
		"Content-type": "application/json",
	};

	return {
		type: FETCH_NAVLOGS,
		promise: axios.delete(`${env("NAV_LOGS_API_URL")}/navlog/${id}`, { headers }),
	};
};
